import { redirect } from 'react-router-dom';
import { getCurrentSubdomain } from '../hostContext';

/**
 * Factory that returns a route loader enforcing a required subdomain.
 *
 * Behavior parity with the previous inline `SubdomainRoute`:
 *   - Current subdomain does not match -> redirect("/").
 *   - Matches -> resolve `null`; the matched element mounts.
 *
 * Runs BEFORE the element renders, so no flash of gated content.
 *
 * Local dev: `localhost:9002` yields subdomain "localhost", so admin routes
 * still redirect. `admin.localhost:9002` yields "admin", so admin routes
 * render. See `.env` and `router/hostContext.js` for details.
 *
 * @param {string} required Required first hostname segment (e.g. "admin").
 * @returns {import('react-router-dom').LoaderFunction}
 */
export const requireSubdomain = (required) => () => {
    if (getCurrentSubdomain() === required) return null;
    return redirect('/');
};
